module.exports = __webpack_public_path__ + "img/Burger King.780795f1.svg";